export enum LaunchType {
	TEST = 'TEST',
	PRE_PROD = 'PRE_PROD',
	PROD = 'PROD'
}
